import select from './select';
export default function min(interable, selector) {
    const values = select(interable, selector);
    return Math.min(...values);
}
